
// https://www.npmjs.com/package/vue-video-player
// docs : https://docs.videojs.com/module-events.html
// example : https://github.surmon.me/vue-video-player/
// example : https://github.com/surmon-china/vue-video-player/blob/master/examples/nuxt-ssr-example/nuxt-ssr-example.vue
import Vue from 'vue'
const VueVideoPlayer = require( 'vue-video-player/dist/ssr' )
Vue.use( VueVideoPlayer )
